export const ROOT_ASSETS_STATE = 'assets';

export const INITIAL_STATE = {
  list: [],
  message: '',
  viewedAssetId: '',
  currentPage: 1,
  totalPages: 1,
  totalCount: 0,
  pageSize: 50,
  selections: [],
  /* prettier-ignore */
  pageSizes: [
		{ label: '50', value: 50 },
		{ label: '100', value: 100 },
		{ label: '150', value: 150 }
	]
};

//array of paths to keys need to be saved
export const AssetsWhiteListKeys = [
  [ROOT_ASSETS_STATE, 'currentPage'],
  [ROOT_ASSETS_STATE, 'pageSize'],
  [ROOT_ASSETS_STATE, 'selections'],
  [ROOT_ASSETS_STATE, 'viewedAssetId']
];
